<div class="form-container">
	<div class="logo-container"><img src="/assets/img/ufcw1262-logo.png" /></div>
	<h3 *ngIf="invalidUrl">
		The QR code that you scanned is invalid. Please contact your union representative for assistance.
	</h3>
	<form [hidden]="invalidUrl" [formGroup]="form">
		<div class="row">
			<div class="col-md-5">
				<label for="firstName">First Name*</label>
				<input type="input" id="firstName" class="form-control" formControlName="firstName" [ngClass]="{'show-validation': showValidation}">
			</div>
			<div class="col-md-5">
				<label for="lastName">Last Name*</label>
				<input type="input" id="lastName" class="form-control" formControlName="lastName" [ngClass]="{'show-validation': showValidation}">
			</div>
			<div class="col-md-2">
				<label for="middleInitial">Middle Initial</label>
				<input type="input" maxlength="1" id="middleInitial" class="form-control" formControlName="middleInitial" [ngClass]="{'show-validation': showValidation}">
			</div>
		</div>
		<div class="section-divider"></div>
		<div class="row">
			<div class="col-md-8">
				<label for="streetAddress">Street Address*</label>
				<input type="input" id="streetAddress" class="form-control" formControlName="streetAddress" [ngClass]="{'show-validation': showValidation}">
			</div>
			<div class="col-md-4">
				<label for="apartmentNumber">Apartment Number</label>
				<input type="input" id="apartmentNumber" class="form-control" formControlName="apartmentNumber" [ngClass]="{'show-validation': showValidation}">
			</div>
		</div>
		<div class="row">
			<div class="col-md-4">
				<label for="city">City*</label>
				<input type="input" id="city" class="form-control" formControlName="city" [ngClass]="{'show-validation': showValidation}">
			</div>
			<div class="col-md-4">
				<label for="state">State*</label>
				<select type="input" id="state" class="form-control" formControlName="state" [ngClass]="{'show-validation': showValidation}">
					<option></option>
					<option value="AL">Alabama</option>
					<option value="AK">Alaska</option>
					<option value="AZ">Arizona</option>
					<option value="AR">Arkansas</option>
					<option value="CA">California</option>
					<option value="CO">Colorado</option>
					<option value="CT">Connecticut</option>
					<option value="DE">Delaware</option>
					<option value="FL">Florida</option>
					<option value="GA">Georgia</option>
					<option value="HI">Hawaii</option>
					<option value="ID">Idaho</option>
					<option value="IL">Illinois</option>
					<option value="IN">Indiana</option>
					<option value="IA">Iowa</option>
					<option value="KS">Kansas</option>
					<option value="KY">Kentucky</option>
					<option value="LA">Louisiana</option>
					<option value="ME">Maine</option>
					<option value="MD">Maryland</option>
					<option value="MA">Massachusetts</option>
					<option value="MI">Michigan</option>
					<option value="MN">Minnesota</option>
					<option value="MS">Mississippi</option>
					<option value="MO">Missouri</option>
					<option value="MT">Montana</option>
					<option value="NE">Nebraska</option>
					<option value="NV">Nevada</option>
					<option value="NH">New Hampshire</option>
					<option value="NJ">New Jersey</option>
					<option value="NM">New Mexico</option>
					<option value="NY">New York</option>
					<option value="NC">North Carolina</option>
					<option value="ND">North Dakota</option>
					<option value="OH">Ohio</option>
					<option value="OK">Oklahoma</option>
					<option value="OR">Oregon</option>
					<option value="PA">Pennsylvania</option>
					<option value="RI">Rhode Island</option>
					<option value="SC">South Carolina</option>
					<option value="SD">South Dakota</option>
					<option value="TN">Tennessee</option>
					<option value="TX">Texas</option>
					<option value="UT">Utah</option>
					<option value="VT">Vermont</option>
					<option value="VA">Virginia</option>
					<option value="WA">Washington</option>
					<option value="WV">West Virginia</option>
					<option value="WI">Wisconsin</option>
					<option value="WY">Wyoming</option>
				</select>
			</div>
			<div class="col-md-4">
				<label for="zip">Zip Code*</label>
				<input type="input" maxlength="5" id="zip" class="form-control" formControlName="zip" [ngClass]="{'show-validation': showValidation}">
			</div>
		</div>
		<div class="section-divider"></div>
		<div class="row">
			<div class="col-md-5">
				<label for="email">Email Address*</label>
				<input type="input" id="email" class="form-control" formControlName="email" [ngClass]="{'show-validation': showValidation}">
			</div>
			<div class="col-md-5">
				<label for="phone">Cell Phone*</label>
				<input type="input" id="phone" class="form-control" formControlName="phone" [ngClass]="{'show-validation': showValidation}" (change)="formatPhone('phone', $event)" (keyup)="formatPhone('phone', $event)">
			</div>
			<div class="col-md-2">
				<label for="commsOptOut">Opt out of text communications?</label>
				<select type="input" id="commsOptOut" class="form-control" formControlName="commsOptOut" [ngClass]="{'show-validation': showValidation}">
					<option value="Yes">Yes</option>
					<option value="No">No</option>
				</select>
			</div>
		</div>
		<div class="row">
			<div class="col-md-3">
				<label for="sex">Sex*</label>
				<select type="input" id="sex" class="form-control" formControlName="sex" [ngClass]="{'show-validation': showValidation}">
					<option></option>
					<option value="Male">Male</option>
					<option value="Female">Female</option>
					<option value="Non Binary">Non Binary</option>
				</select>
			</div>
			<div class="col-md-3">
				<label for="dob">Date of Birth*</label>
				<input type="text" id="dob" class="form-control" formControlName="dob" placeholder="MM/DD/YYYY" [ngClass]="{'show-validation': showValidation, 'invalid-date': !isValidDob()}" (change)="formatDate('dob', $event)" (keyup)="formatDate('dob', $event)">
			</div>
			<div class="col-md-3">
				<label for="ssn">Social Security Number*</label>
				<input type="input" id="ssn" class="form-control" formControlName="ssn" [ngClass]="{'show-validation': showValidation}" (change)="formatSsn($event)" (keyup)="formatSsn($event)">
			</div>
			<div class="col-md-3">
				<label for="relationship">Relationship Status*</label>
				<select type="input" id="relationship" class="form-control" formControlName="relationship" [ngClass]="{'show-validation': showValidation}">
					<option></option>
					<option value="Married">Married</option>
					<option value="Single">Single</option>
					<option value="Separated">Separated</option>
					<option value="Divorced">Divorced</option>
				</select>
			</div>
		</div>
		<div class="row">
			<div class="col-md-3">
				<label for="dateOfHire">Initial Date of Hire*</label>
				<input type="text" id="dateOfHire" class="form-control" formControlName="dateOfHire" placeholder="MM/DD/YYYY" [ngClass]="{'show-validation': showValidation, 'invalid-date': !isValidDoh()}" (change)="formatDate('dateOfHire', $event)" (keyup)="formatDate('dateOfHire', $event)">
			</div>
			<div class="col-md-3">
				<label for="jobClass">Job Class*</label>
				<select type="input" id="jobClass" class="form-control" formControlName="jobClass" [ngClass]="{'show-validation': showValidation}">
					<option></option>
					<option value="Clerk">Clerk</option>
					<option value="Service Clerk">Service Clerk</option>
					<option value="Maint/Porter">Maint/Porter</option>
				</select>
			</div>
			<div class="col-md-3">
				<label for="employmentType">Employment Type*</label>
				<select type="input" id="employmentType" class="form-control" formControlName="employmentType" [ngClass]="{'show-validation': showValidation}">
					<option></option>
					<option value="Part-time">Part-time</option>
					<option value="Full-time">Full-time</option>
				</select>
			</div>
			<div class="col-md-3">
				<label for="previousLocalNo">Previous Affiliation Local No.</label>
				<input type="input" id="previousLocalNo" class="form-control" formControlName="previousLocalNo" [ngClass]="{'show-validation': showValidation}">
			</div>
		</div>
		<div class="section-divider"></div>
		<div class="row">
			<div class="col-md-4">
				<label for="beneficiaryFirstName">Beneficiary First Name*</label>
				<input type="input" id="beneficiaryFirstName" class="form-control" formControlName="beneficiaryFirstName" [ngClass]="{'show-validation': showValidation}">
			</div>
			<div class="col-md-4">
				<label for="beneficiaryLastName">Beneficiary Last Name*</label>
				<input type="input" id="beneficiaryLastName" class="form-control" formControlName="beneficiaryLastName" [ngClass]="{'show-validation': showValidation}">
			</div>
			<div class="col-md-2">
				<label for="beneficiaryRelationship">Relationship*</label>
				<select id="shareGranted" class="form-control" formControlName="beneficiaryRelationship" [ngClass]="{'show-validation': showValidation}">
					<option></option>
					<option>Family</option>
					<option>Friend</option>
					<option>Estate of</option>
				</select>
			</div>
			<div class="col-md-2">
				<label for="shareGranted">Beneficiary % of Share Granted*</label>
				<input type="number" id="shareGranted" class="form-control" formControlName="shareGranted" [ngClass]="{'show-validation': showValidation}" (change)="beneficiaryAmountChanged()">
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<label for="beneficiaryPhone">Beneficiary Phone Number*</label>
				<input type="input" id="beneficiaryPhone" class="form-control" formControlName="beneficiaryPhone" [ngClass]="{'show-validation': showValidation}" (change)="formatPhone('beneficiaryPhone', $event)" (keyup)="formatPhone('beneficiaryPhone', $event)">
			</div>
			<div class="col-md-6">
				<label for="beneficiaryEmail">Beneficiary Email Address</label>
				<input type="input" id="beneficiaryEmail" class="form-control" formControlName="beneficiaryEmail" [ngClass]="{'show-validation': showValidation}">
			</div>
		</div>
		<div class="section-divider"></div>
		<div class="row">
			<div class="col-md-4">
				<label for="beneficiaryTwoFirstName">Second Beneficiary First Name<ng-container *ngIf="hasTwoBeneficiaries()">*</ng-container></label>
				<input type="input" id="beneficiaryTwoFirstName" class="form-control" formControlName="beneficiaryTwoFirstName" [ngClass]="{'show-validation': showValidation}">
			</div>
			<div class="col-md-4">
				<label for="beneficiaryTwoLastName">Second Beneficiary Last Name<ng-container *ngIf="hasTwoBeneficiaries()">*</ng-container></label>
				<input type="input" id="beneficiaryTwoLastName" class="form-control" formControlName="beneficiaryTwoLastName" [ngClass]="{'show-validation': showValidation}">
			</div>
			<div class="col-md-2">
				<label for="beneficiaryTwoRelationship">Second Beneficiary Relationship<ng-container *ngIf="hasTwoBeneficiaries()">*</ng-container></label>
				<select id="shareGranted" class="form-control" formControlName="beneficiaryTwoRelationship" [ngClass]="{'show-validation': showValidation}">
					<option></option>
					<option>Family</option>
					<option>Friend</option>
					<option>Estate of</option>
				</select>
			</div>
			<div class="col-md-2">
				<label for="shareGrantedTwo">Beneficiary % of Share Granted</label>
				<input type="number" id="shareGrantedTwo" class="form-control" formControlName="shareGrantedTwo" [ngClass]="{'show-validation': showValidation}">
			</div>
		</div>
		<div class="row">
			<div class="col-md-6">
				<label for="beneficiaryTwoPhone">Second Beneficiary Phone Number<ng-container *ngIf="hasTwoBeneficiaries()">*</ng-container></label>
				<input type="input" id="beneficiaryTwoPhone" class="form-control" formControlName="beneficiaryTwoPhone" [ngClass]="{'show-validation': showValidation}" (change)="formatPhone('beneficiaryTwoPhone', $event)" (keyup)="formatPhone('beneficiaryTwoPhone', $event)">
			</div>
			<div class="col-md-6">
				<label for="beneficiaryTwoEmail">Second Beneficiary Email Address</label>
				<input type="input" id="beneficiaryTwoEmail" class="form-control" formControlName="beneficiaryTwoEmail" [ngClass]="{'show-validation': showValidation}">
			</div>
		</div>
		<div class="row button-row">
			<div class="col-md-12">
				<button type="button" class="btn btn-md btn-primary" (click)="submit()">Submit</button>
			</div>
			<div class="col-md-12 red" *ngIf="showValidation && !form.valid">
				One or more fields are invalid.<br>
				Please check the form and try again.
			</div>
		</div>
	</form>
</div>

<ng-template #confirmationDialog>
	<div class="modal-header">
		<h5 class="modal-title"><em class="fas fa-check"></em> Email Confirmation</h5>
	</div>
	<div class="modal-body" [ngClass]="{'loading in': submissionStatus === 'sending'}">
		<ng-container *ngIf="unsubmittedForm || submissionStatus === 'sending'">
			<p>You will receive an email to finalize your application submission. Is this email address correct?</p>
			<p>{{ form.getRawValue()['email'] }}</p>
		</ng-container>
		<ng-container *ngIf="submissionStatus === 'success'">
			<p>Your application has been submitted successfully. You will receive an email shortly.</p>
		</ng-container>
		<ng-container *ngIf="submissionStatus === 'error'">
			<p>There was an error submitting your application. Please try again later.</p>
		</ng-container>
	</div>
	<div class="modal-footer no-bg">
		<ng-container *ngIf="unsubmittedForm">
			<button type="button" class="btn btn-primary btn-md" (click)="submitForm()">Yes</button>
			<button type="button" class="btn btn-default btn-md" data-dismiss="modal" (click)="modalRef.hide()">No</button>
		</ng-container>
	</div>
</ng-template>